enum TermRoutesAPI {
  TERM_IS_READ = '/customer-portal-service/Terms/Read/:type',
  TERM_READ = '/customer-portal-service/Terms/Read/:type/:id',
}

export {
  TermRoutesAPI,
};
